/**
 * TextInput / NumberInputNew builder — verbatim from v1 build_elements.js
 * (research/03 §3; REQ-ELEM-2/3). TextInput deliberately renders a NUMBER
 * input (§15.1); the onchange attribute contains a literal newline (§15.11).
 */
import { appState } from "../state/app-state";
import { generateStep } from "../common/common-utils";
import { getConditionalDisplay, getToolTipHtml, parsedName , getElementWidthClass, t , dirAttr } from "./base";

export function buildNumberInput(element: any): string {
  var minValue = element.MinValue != undefined ? element.MinValue : 0;
  var maxValue = element.Maxvalue != undefined ? element.Maxvalue : 100000;
  let elemMaxDecimal =
    element.Maxdecimals != undefined ? element.Maxdecimals : 0;
  //minValue = Math.min(minValue, elemMaxDecimal);
  //maxValue = Math.round(maxValue, elemMaxDecimal);
  let isQuantity = element.isQuantity != undefined ? element.isQuantity : false;
  var step;
  if (element.StepInterval != null && element.StepInterval > 0) {
    step = element.StepInterval;
  } else {
    step = element.Maxdecimals != undefined ? generateStep(element.Maxdecimals) : 1;
  }
  var conditionalDisplay = getConditionalDisplay(element);
  let toolTipHtml = getToolTipHtml(element, "span");
  // Merchant toggle (builder "Show +/- arrows"); the class opts into the
  // spinner-hiding rules in the app stylesheet. Absent/false = legacy markup.
  let stepperClass = element.HideStepper ? " cpc-no-stepper" : "";
  // Issue #82: DefaultValue is meant to mirror MinValue (the API forces this on
  // every save of a NumberInputNew element), but a calculator saved before that
  // normalization existed can still carry a stale DefaultValue below MinValue
  // (e.g. 0 with MinValue=1). Rendering that verbatim fed a zero/below-minimum
  // denominator into the very first price calc on page load, before any user
  // interaction could trigger CheckNumberInputValidity's own min-enforcement.
  // Clamp the initial rendered value up to MinValue so the first calc never
  // sees a below-minimum number. Only applies when the configured minimum is
  // actually above zero — a MinValue of 0 (the default for most elements,
  // including every "no minimum configured" case) offers no protection to
  // enforce, and clamping an empty/NaN DefaultValue to 0 there would change
  // the pinned "invalid input → NaN propagates through the formula" behavior
  // (FORM-022a/b, FORM-025b) for elements that were never near this bug.
  let initialValue = element.DefaultValue;
  if (minValue > 0) {
    let parsedDefaultValue = parseFloat(element.DefaultValue);
    if (isNaN(parsedDefaultValue) || parsedDefaultValue < minValue) {
      initialValue = minValue;
    }
  }
  return (
    "<div class='element" + getElementWidthClass(element) + "' data-element='" +
    element.Identifier +
    "' " +
    conditionalDisplay.conditionalTemplate +
    "><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.Name) + ">" +
    t(element.Name) +
    toolTipHtml +
    `</label><input onkeyup='PriceUpdation(this)' onchange='PriceUpdation(
      this)' data-identifier='` +
    element.Identifier +
    "' class='calc-prop numInput-cpc" +
    stepperClass +
    "' step='" +
    step +
    "' min='" +
    minValue +
    "' max='" +
    maxValue +
    "' onblur='CheckNumberInputValidity(this," +
    elemMaxDecimal +
    ");' data-stepinterval='" +
    (element.StepInterval != null ? element.StepInterval : "") +
    "' data-rangeenabled='" +
    element.value_range_enabled +
    "' data-maxdecimals='" +
    elemMaxDecimal +
    "' data-calcname='" +
    element.Name +
    "' name=\"properties[" +
    parsedName(element.Name) +
    "]\" data-cpc_isquantity='" +
    isQuantity +
    "' value='" +
    initialValue +
    "' type='number'/></div>"
  );
}
